import React from "react";
import { Route, Routes, useSearchParams } from "react-router-dom";
import { AppRoutes } from "./AppRoutes";
import FinalisationCompte from "src/pages/finalisation/FinalisationCompte";
import Accueil from "src/pages/accueil/Accueil";
import PrivateRoute from "src/routes/PrivateRoute";
import RattachementCompte from "src/pages/rattachement/RattachementCompte";
import HistoriqueConnexion from "src/pages/historiqueconnexion/HistoriqueConnexion";
import FacturesFER from "src/pages/factures/FacturesFER";
import DocumentsFER from "src/pages/documents/DocumentsFER";
import ContactService from "src/pages/contactservice/ContactService";
import InfoPerso from "src/pages/infoperso/InfoPerso";
import AdminContainer from "src/pages/admin/AdminContainer";

const AppRouteComposants = () => {

  const [searchParams] = useSearchParams();

  return (
    <Routes>
      <Route path={AppRoutes.FINALISATION_PATH.route} element={<FinalisationCompte shortId={searchParams.get("shortId")}/>}/>
      <Route path={AppRoutes.RATTACHEMENT_PATH.route}
             element={<RattachementCompte sourceUid={searchParams.get("sourceUid")} targetEmailAddress={searchParams.get("targetEmailAddress")}/>}/>
      <Route path="/" element={<PrivateRoute/>}>
        {/* Routes accessibles uniquement pour les utilisateurs authentifes. Si pas authentifé, alors redirige vers la page de login */}
        <Route path={AppRoutes.ACCUEIL_PATH.route} element={<Accueil/>}/>
        <Route path={AppRoutes.CONTACT_SERVICE_PATH.route} element={<ContactService/>}/>
        <Route path={AppRoutes.INFO_PERSO_PATH.route} element={<InfoPerso/>}/>
        <Route path={AppRoutes.HISTO_CONNEXION_PATH.route} element={<HistoriqueConnexion/>}/>
        <Route path={AppRoutes.FACTURES_FER_PATH.route} element={<FacturesFER factureId={Number(searchParams.get("factureId"))}/>}/>
        <Route path={AppRoutes.DOCUMENTS_FER_PATH.route} element={<DocumentsFER/>}/>
        <Route path={AppRoutes.ADMIN_PATH.route} element={<AdminContainer/>}/>
      </Route>

    </Routes>
  );
};

export default AppRouteComposants;
